import React from 'react';
import FormList from '../../../components/common/Forms/FormList';
import { ProtectedRoute, PageGuard } from '../../../components/common/security/ProtectedRoute';

const ToFormList: React.FC = () => {
  return (
    <ProtectedRoute>
      <PageGuard>
        <div style={{ padding: 0 }}>
          <FormList />
        </div>
      </PageGuard>
    </ProtectedRoute>
  );
};

export default ToFormList;
